export default __webpack_public_path__ + "static/media/windpark--bockhorn_DJI_0299.c4f442bb.jpg";